import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Breadcrumb, Button, Col, Descriptions, Row, Spin, Table } from 'antd';
import { APP_LOCAL_DATE_FORMAT, AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { getSession } from 'app/shared/reducers/authentication';
import React, { useEffect } from 'react';
import { TextFormat } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { getProfesseurAbsences, resetAbsences } from '../cours/absence-reducer';
import { getEcole } from '../ecole/ecole.reducer';
import { getProfesseur } from './personnel.reducer';

export const AbsencesProfesseur = (props: RouteComponentProps<{ ecoleid: string; id: string }>) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getSession);
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getProfesseur(props.match.params.id));
    dispatch(getProfesseurAbsences(props.match.params.id));
  }, []);
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const professeur = useAppSelector(state => state.professeur.entity);
  const loading = useAppSelector(state => state.professeur.loading);
  const absences = useAppSelector(state => state.absences.entities);

  const columns = [
    {
      title: 'Cours',
      dataIndex: 'cours',
      key: 'cours',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: date => date && <TextFormat type="date" value={date} format={APP_LOCAL_DATE_FORMAT} />,
    },
  ];
  const onDeleteAbsences = () => {
    const entity = {
      ...professeur,
      professeurId: props.match.params.id,
    };
    dispatch(resetAbsences(entity));
  };

  const data = absences?.map(absence => ({
    cours:
      absence != null &&
      absence?.calendarEntry?.matiere.nom +
        ', ' +
        absence?.calendarEntry?.heureDebut +
        '-' +
        absence?.calendarEntry?.heureFin +
        ', ' +
        absence?.calendarEntry?.classe.nom,
    date: absence?.date,
  }));

  return (
    <div>
      <Breadcrumb className="p-4">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/professeur/${currentEcole && currentEcole.id}`}>Professeurs</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/professeur/${currentEcole && currentEcole.id}/${professeur.id}/details`}>Details</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`professeur/${currentEcole && currentEcole.id}/${professeur.id}/absences`}>Absences</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className="p-4">
        <Row>
          <Col lg={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 10 }} md={{ span: 10 }}>
            <span>
              <Descriptions column={1}>
                <Descriptions.Item label="Matricule">{professeur.matricule}</Descriptions.Item>
                <Descriptions.Item label="Classes">{professeur.classes.map(c => c.nom).join(', ')}</Descriptions.Item>
                <Descriptions.Item label="Matières">{professeur.matieresEcole.map(m => m.nom).join(', ')}</Descriptions.Item>
              </Descriptions>
            </span>
          </Col>
          <h3 className="center">{professeur.prenom + ' ' + professeur.nom} </h3>
        </Row>
        {isAdmin && (
          <Row style={{ justifyContent: 'right' }}>
            <Button key="back" style={{ backgroundColor: 'red', color: 'white' }} onClick={onDeleteAbsences}>
              <FontAwesomeIcon icon={faTrash} title="Supprimer les absences" />
              &nbsp; Reset Absences
            </Button>
          </Row>
        )}
        <Row className="table-reponsive p-4 justify-content-center">
          <Col lg={{ span: 16 }} xs={{ span: 24 }} sm={{ span: 14 }} md={{ span: 18 }}>
            <h4 className="center"> Historiques des Absences</h4>
            <div className="table-responsive">
              <Spin spinning={loading} tip="Chargement...">
                <Table columns={columns} dataSource={data?.reverse()} />
              </Spin>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AbsencesProfesseur;
